module.exports = __webpack_public_path__ + "static/img/6.0710c3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/6.png
// module id = vQfz
// module chunks = 0